import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { OrderStatus, OrderStatusName } from '@frontend/order/types';

const ID = 'order-status-select';

export interface OrderStatusSelectProps extends Omit<SelectInputV2Props<OrderStatusName>, 'options'> {
    subset?: OrderStatusName[];
}

const DEFAULT_ORDER_STATUS_OPTIONS = [OrderStatusName.PENDING, OrderStatusName.PROCESSING, OrderStatusName.COMPLETED, OrderStatusName.CANCELLED];

export const OrderStatusSelect = (props: OrderStatusSelectProps) => {
    const options = props.subset ?? DEFAULT_ORDER_STATUS_OPTIONS;

    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            isClearable={props.isClearable}
            className={props.className}
            options={options.map((c) => ({ label: OrderStatus.format(c), value: c }))}
            value={props.value}
            label={props.label || 'Order state'}
            required={props.required}
            onSelect={props.onSelect}
        />
    );
};
